import {
  BUILD_AI_USAGE_SOURCES,
  type AiUsageSource,
} from "../../../shared/aiUsageSources";

export const AI_USAGE_ACTIVITIES = ["build", "run", "monitor"] as const;
export type AiUsageActivity = (typeof AI_USAGE_ACTIVITIES)[number];

export const AI_USAGE_ACTIVITY_LABELS: Record<AiUsageActivity, string> = {
  build: "Build",
  run: "Run",
  monitor: "Monitor",
};

export function classifyAiUsageActivity(
  source: AiUsageSource | string
): AiUsageActivity | null {
  if (source === "workflow_run") return "run";
  if (source === "autofix" || source === "autotune") return "monitor";
  if ((BUILD_AI_USAGE_SOURCES as readonly string[]).includes(source)) {
    return "build";
  }
  return null;
}

export type ActivityCostBucket = {
  estimatedCostUsd: number | null;
  requestCount: number;
};

export function emptyActivityBuckets(): Record<
  AiUsageActivity,
  ActivityCostBucket
> {
  return {
    build: { estimatedCostUsd: null, requestCount: 0 },
    run: { estimatedCostUsd: null, requestCount: 0 },
    monitor: { estimatedCostUsd: null, requestCount: 0 },
  };
}

// Cost is passed in already computed so each caller keeps its own pricing source.
export function addRecordToActivityBuckets(
  buckets: Record<AiUsageActivity, ActivityCostBucket>,
  record: { source: string; requestCount: number | null },
  cost: number | null
) {
  const activity = classifyAiUsageActivity(record.source);
  if (!activity) return;
  const bucket = buckets[activity];
  bucket.requestCount += record.requestCount ?? 0;
  if (cost != null) {
    bucket.estimatedCostUsd = (bucket.estimatedCostUsd ?? 0) + cost;
  }
}
